import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Product from '../parts/Product';
import { getGraphQlCollectionId } from '../../helpers';
import { fetchCollection } from '../../actions';
import { find } from 'lodash';
import handleViewport from 'react-in-viewport';

import classNames from 'classnames';

const Collection = ({inViewport, enterCount, leaveCount, forwardedRef, ...props}) => {
  const [ hovered, setHovered ] = useState(false);

  useEffect(() => {
    if(!props.collection){
      props.fetchCollection(props.collection_id);
    }
  }, [])

  return (
    <div
      ref={forwardedRef}
      className={classNames(`module module--collection module--collection--${props.layout}`, {
        'module--visible': inViewport
      })}
      style={{
         backgroundColor: props.background,
         color: props.foreground
      }}>
      <div className="inner">
        <div className={classNames('collection', `collection--${props.layout}`, {
          'collection--hovered': hovered
        })}>

          {(props.collection && props.collection.products) ?
            props.layout == 'highlight' ?
              <React.Fragment>
                <div className="left">
                  {props.collection.products[0] &&
                  <Product
                    product={props.collection.products[0]}
                    visible={inViewport}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    />
                  }
                  {props.collection.products[1] &&
                    <Product
                      product={props.collection.products[1]}
                      visible={inViewport}
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                      />
                  }
                </div>
                <div className="right">
                  {props.collection.products[2] &&
                    <Product
                      product={props.collection.products[2]}
                      visible={inViewport}
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                      />
                    }
                </div>
              </React.Fragment>
              :
              props.collection.products.map((product, i) => (
                <Product
                  key={i}
                  product={product}
                  visible={inViewport}
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                  />
              ))
            : null
          }
        </div>
      </div>
    </div>
  );
}



const mapStateToProps = (state, ownProps) => {
  const { collections } = state.collections;
  const collectionId = getGraphQlCollectionId(ownProps.collection_id);

  return {
    collection: find(collections, {id: collectionId})
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchCollection: collection => {
      dispatch(fetchCollection(collection));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(handleViewport(Collection));
